export const buildConversationTimelineUrl = (
  customerId: string,
  messageId?: string | null
): string => {
  const baseUrl = `/inbox/conversations/${encodeURIComponent(customerId)}`;
  const targetMessageId = messageId?.trim();
  return targetMessageId
    ? `${baseUrl}?messageId=${encodeURIComponent(targetMessageId)}`
    : baseUrl;
};
